import { createSelector } from 'reselect';

import { selectEditorBlocks } from '../EditorContainer/selectors';

import { getDraftJSFieldsByType } from '../../utils/schema';
import getBlockCharCount from '../../utils/getBlockCharCount';

export const selectGlobalCounter = () => createSelector(
  selectEditorBlocks(),
  data => data.reduce((counter, block) => counter + getDraftJSFieldsByType(block.get('type')).reduce((sum, name) => {
    const blockContent = block.get(name);

    return blockContent
      ? sum + getBlockCharCount(blockContent)
      : sum;
  }, 0),
  0)
);
